import React from 'react';
import type { StepperStep } from '../../../types';

interface StepperProps {
  steps: StepperStep[];
  currentStepId: string;
  onStepClick: (step: StepperStep) => void;
}

const Stepper: React.FC<StepperProps> = ({ steps, currentStepId, onStepClick }) => {

  const isCurrentStep = (step: StepperStep) => {
    return step.id === currentStepId;
  };

  const renderActiveStepIcon = (index: number) => {
    return (
      <div className="bg-page-bg-light px-1 relative z-10">
      <div
        className="w-6 h-6 sm:w-5 sm:h-5 text-white flex items-center justify-center ring-offset-1 ring-black dark:ring-offset-card-bg-dark"
        style={{ borderRadius: 'var(--td-radius, 9999px)', backgroundColor: 'var(--td-button-color, #000000)' }}>
        <span className="text-sm sm:text-base font-semibold leading-normal">{index + 1}</span>
      </div>
      </div>
    )
  };

  const renderClassName = (step: StepperStep) => {
    if (step.status === 'completed' || isCurrentStep(step)) {
      return 'text-black';
    }
    return 'text-gray-300 dark:text-gray-400';
  };

  return (
    <div className="w-full pb-4 pt-6 sm:py-6 lg:hidden">
      <div className="flex justify-between items-baseline max-w-4xl mx-auto px-4 steps-container">
        {steps.map((step, index) => {
          const getStepClassName = () => {
            if (step.status === 'completed') return 'step-completed';
            if (isCurrentStep(step)) return 'step-current';
            return 'step-pending';
          };
          
          return (
          <React.Fragment key={step.id}>
            <div className={`flex flex-col items-center text-center cursor-pointer ${getStepClassName()}`} onClick={() => onStepClick(step)} tabIndex={0}
                 role="button"
                 aria-label={`Ir para a etapa ${step.name}`}
                 aria-selected={isCurrentStep(step)}
            >
              {step.status === 'completed' || isCurrentStep(step) ? (
                renderActiveStepIcon(index)
              ) : (
                <div className="bg-page-bg-light px-1 relative z-10">
                <div
                  className="w-6 h-6 sm:w-5 sm:h-5 bg-medium-gray dark:bg-gray-700 text-gray-50 dark:text-gray-300 flex items-center justify-center"
                  style={{ borderRadius: 'var(--td-radius, 9999px)' }}>
                  <span className="text-sm sm:text-base font-semibold leading-normal">{index + 1}</span>
                </div>
                </div>
              )}
              <p
                className={`mt-2 text-xs sm:text-xs font-bold ${renderClassName(step)}`}>
                {step.name}
              </p>
            </div>
          </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default Stepper; 